export const LocalEvents = {
  SettingsActivateMainMenu: '(settings:activate-main-menu)',
  SettingsActivateAudioMenu: '(settings:activate-audio-menu)',
  SettingsActivateSubtitlesMenu: '(settings:activate-subtitles-menu)',
  SettingsActivateSubtitlesLanguageMenu:
    '(settings:activate-subtitles-language-menu)',
  SettingsActivateSubtitlesCustomMenu:
    '(settings:activate-subtitles-custom-menu)',
  SettingsActivateSubtitlesFontFamilyMenu:
    '(settings:activate-subtitles-font-family-menu)',
  SettingsActivateSubtitlesFontColorMenu:
    '(settings:activate-subtitles-font-color-menu)',
  SettingsActivateSubtitlesFontSizeMenu:
    '(settings:activate-subtitles-font-size-menu)',
  SettingsActivateSubtitlesFontOpacityMenu:
    '(settings:activate-subtitles-font-opacity-menu)',
  SettingsActivateSubtitlesBackgroundColorMenu:
    '(settings:activate-subtitles-background-color-menu)',
  SettingsActivateSubtitlesBackgroundOpacityMenu:
    '(settings:activate-subtitles-background-opacity-menu)',
  SettingsActivateSubtitlesWindowColorMenu:
    '(settings:activate-subtitles-window-color-menu)',
  SettingsActivateSubtitlesWindowOpacityMenu:
    '(settings:activate-subtitles-window-opacity-menu)',
  SettingsActivateSubtitlesCharacterEdgeStyleMenu:
    '(settings:activate-subtitles-character-edge-style-menu)',
  SettingsActivateQualityMenu: '(settings:activate-quality-menu)',
  SettingsCloseMenu: '(settings:close-menu)',
}
